export function isSafari() {
  if (!import.meta.client) {
    return false
  }

  return 'GestureEvent' in window
}

export function getAnimationBehaviour(): ScrollBehavior {
  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  return prefersReducedMotion ? 'auto' : 'smooth'
}
